import React from "react";
import { projects } from "../../helpers/data.js";

import "./projects.scss";
import SectionHeader from "../../components/SectionHeader";
import { SiGithub } from "react-icons/si";
import { IoArrowRedo } from "react-icons/io5";

const Card = ({ src, title, description, builtWith, repo, url }) => {
  return (
    <div className="card-wrapper">
      <div className="card-info">
        <h1 className="card-info-title">{title}</h1>
        <h2 className="card-info-description">{description}</h2>
        <div className="card-info-tools">
          <p>Built with:</p>
          <ul>
            {builtWith.map((tool, i) => (
              <li key={i}>{tool}</li>
            ))}
          </ul>
        </div>
        <div className="card-info-links">
          <div className="repo-link">
            <a href={repo} target="_blank" rel="noopener noreferrer">
              <span data-link-alt="Code">Code</span> <SiGithub />
            </a>
          </div>
          <div className="url-link">
            <a href={url} target="_blank" rel="noopener noreferrer">
              <span data-link-alt="Deployment">Deployment</span> <IoArrowRedo />
            </a>
          </div>
        </div>
      </div>
      <div
        className="card-image"
        style={{ backgroundImage: `url(${src})` }}
      ></div>
    </div>
  );
};

export const Projects = ({ src, index }) => {
  const subtitle =
    "A collection of tasks, mini-projects and fullstack projects i have worked on during my journey at DCI.";

  return (
    <section
      className="projects section cards-wrapper"
      id="projects"
      data-scroll-section
    >
      <div className="section-wrapper">
        <SectionHeader title="Projects." subtitle={subtitle} />

        <div className="projects-content content">
          {projects.map((project, index) => {
            return <Card key={src} index={index} {...project} />;
          })}
        </div>
      </div>
    </section>
  );
};
